export const GLOBAL_EVENTS = {
    CHECK_OWNER_STATUS: 'CHECK_OWNER_STATUS',
    OWNER_STATUS: 'OWNER_STATUS',
    MOOD_CHANGED: 'MOOD_CHANGED',
    SESSION_CONNECTED: 'SESSION_CONNECTED',
    SESSION_DISCONNECTED: 'SESSION_DISCONNECTED',
    AVATAR_CHANGED: 'AVATAR_CHANGED',
    FRIENDS_LOADED: 'FRIENDS_LOADED', ///api
}